import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import promotionReducer from "./promotedProducts";

export const store = configureStore({
  reducer: { auth: authReducer, promo: promotionReducer },
});
